import { oids } from "../lib/oids";
import { call } from "../lib/jsonrpc";

export const networkDeviceCiscoSpectrumEntryRemove = (id, entryId) => {
  return call('networkDeviceSnmpSet', { id, oid: oids.ccsSpectrumRequestStatus + '.' + entryId, value: 6, type: 2 });
}

export default networkDeviceCiscoSpectrumEntryRemove;